"use client";

import { Button } from "@devhop/ui";
import { Printer } from "lucide-react";
import type { WarehouseLocationRow } from "../api/client";

type Props = {
  locations: WarehouseLocationRow[];
  shopName?: string;
};

/** ພິມປ້າຍ QR/barcode ຕຳແໜ່ງ — ໃຊ້ window.print ກັບ HTML ຊົ່ວຄາວ */
export function WarehouseLocationQrPrintButton({ locations, shopName }: Props) {
  function handlePrint() {
    const active = locations.filter((l) => l.isActive && l.scanCode);
    if (active.length === 0) return;

    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>Location labels</title>
<style>
  body { font-family: system-ui, sans-serif; margin: 0; padding: 8mm; }
  .grid { display: flex; flex-wrap: wrap; gap: 6mm; }
  .label {
    width: 70mm; min-height: 40mm; border: 1px solid #ccc; padding: 4mm;
    box-sizing: border-box; page-break-inside: avoid;
  }
  .code { font-size: 16pt; font-weight: 700; font-family: monospace; }
  .scan { font-size: 11pt; font-family: monospace; margin-top: 2mm; color: #333; }
  .shop { font-size: 9pt; color: #666; margin-bottom: 2mm; }
  .name { font-size: 10pt; margin-top: 1mm; }
</style></head><body><div class="grid">
${active
  .map(
    (l) => `<div class="label">
  ${shopName ? `<div class="shop">${escapeHtml(shopName)}</div>` : ""}
  <div class="code">${escapeHtml(l.code)}</div>
  ${l.name ? `<div class="name">${escapeHtml(l.name)}</div>` : ""}
  <div class="scan">${escapeHtml(l.scanCode ?? "")}</div>
</div>`,
  )
  .join("")}
</div></body></html>`;

    const w = window.open("", "_blank", "width=800,height=600");
    if (!w) return;
    w.document.write(html);
    w.document.close();
    w.focus();
    w.print();
  }

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handlePrint}
      disabled={locations.length === 0}
    >
      <Printer className="size-4" aria-hidden />
      ພິມປ້າຍຕຳແໜ່ງ
    </Button>
  );
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}
